import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import WhatsNewModal from './WhatsNewModal';
const queryClient = new QueryClient();
export default function WhatsNewModalWrapper(props) {
    return (React.createElement(QueryClientProvider, { client: queryClient },
        React.createElement(WhatsNewModal, Object.assign({}, props))));
}
